export class JsonGenerator {
    generateAPI(jsonObj) {
        if (!jsonObj || !jsonObj.blocks) return { jsonObjAPI: {}, jsonObjAPIRequired: [] };
        var jsonObjAPI = {}
        var jsonObjAPIRequired = []
        for (var i = 0; i < jsonObj.blocks.length; i++) {
            var block = jsonObj.blocks[i]
            for (var b = 0; b < block.rows.length; b++) {
                var row = block.rows[b] 
                if (row.values !== undefined) {
                    var values = row.values
                    for (var v = 0; v < values.length; v++) {
                        var apiVal = this.getApiValue(values[v])
                        if (apiVal !== undefined) {
                            if (jsonObjAPI[row.key] === undefined) {
                                jsonObjAPI[row.key] = {}

                            }
                            jsonObjAPI[row.key][values[v]['column']] = apiVal
                            jsonObjAPIRequired.push(row.key+":"+values[v]['column'])
                        }
                    }
                } else {
                    if (row.style === undefined || row.style==='') {
                        if (row.required){
                            jsonObjAPIRequired.push(row.key)
                        }
                        jsonObjAPI[row.key] = this.getApiValue(row)
                    }
                }
            }
        }
        return {jsonObjAPI:jsonObjAPI,jsonObjAPIRequired:jsonObjAPIRequired};
    }

    getApiValue(row) {
        if (row.type === 'string') {
            return 'sample_value';
        }
        if (row.type === 'number' || row.formula!==undefined) {
            return 1234;
        }
        if (row.type === 'date') {
            return '2018-11-21'
        }
        if (row.type === 'checkbox') {
            return true;
        }
        if (row.type === 'option') {
            return row.column;
        }
        return undefined;
    }

}